import { createStore } from 'vuex'

export default createStore({
  state: {
    reports: [] // 存储体质报告列表
  },
  getters: {
    reports: state => state.reports,
    reportCount: state => state.reports.length
  },
  mutations: {
    ADD_REPORT(state, report) {
      // 生成报告编号：S + 随机数字（类似 S7541254256589623655）
      // 生成一个19位的随机数字字符串
      const generateRandomNumber = (length) => {
        let result = ''
        for (let i = 0; i < length; i++) {
          result += Math.floor(Math.random() * 10)
        }
        return result
      }
      const reportNumber = 'S' + generateRandomNumber(19)
      // 格式化测评时间：YYYY-MM-DD HH:mm:ss
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hour = String(now.getHours()).padStart(2, '0')
      const minute = String(now.getMinutes()).padStart(2, '0')
      const second = String(now.getSeconds()).padStart(2, '0')
      const evaluationTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      
      state.reports.unshift({
        id: Date.now(),
        ...report,
        reportNumber,
        evaluationTime,
        createTime: new Date().toLocaleString()
      })
      // 保存到 localStorage
      localStorage.setItem('constitutionReports', JSON.stringify(state.reports))
    },
    DELETE_REPORT(state, id) {
      state.reports = state.reports.filter(report => report.id !== id)
      localStorage.setItem('constitutionReports', JSON.stringify(state.reports))
    },
    INIT_REPORTS(state) {
      const saved = localStorage.getItem('constitutionReports')
      if (saved) {
        state.reports = JSON.parse(saved)
      }
    }
  },
  actions: {
    addReport({ commit }, report) {
      commit('ADD_REPORT', report)
    },
    deleteReport({ commit }, id) {
      commit('DELETE_REPORT', id)
    },
    initReports({ commit }) {
      commit('INIT_REPORTS')
    }
  },
  modules: {
  }
})
